import { useRef, useState, useEffect } from 'react'
import { RevenueCenterImage } from './RevenueCenter.styled'

const LazyRevenueCenterImage = ({ imageUrl }: { imageUrl?: string }) => {
  const imgRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { threshold: 0.1 }
    )

    if (imgRef.current) {
      observer.observe(imgRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  const bgStyle =
    imageUrl && isVisible ? { backgroundImage: `url(${imageUrl})` } : undefined

  return (
    <RevenueCenterImage ref={imgRef} style={bgStyle}>
      &nbsp;
    </RevenueCenterImage>
  )
}

export default LazyRevenueCenterImage
